<template>
  <section class="md:mx-4.5 md:mb-12">
    <div
      class="mx-auto max-w-content-container overflow-hidden border-t-0 border-grey-600 md:rounded-b-xl md:border"
    >
      <div
        class="border-b border-grey-600 bg-white px-4.5 py-5 md:border-none md:px-12 md:py-10"
      >
        <h2 class="mb-4 text-h5 md:text-h3">
          {{ title }}
        </h2>
        <ul
          class="grid grid-cols-2 gap-4 text-paragraph-sm md:gap-x-12 md:text-paragraph-xl lg:grid-cols-4"
        >
          <li class="items-start gap-x-4 lg:flex">
            <div class="mb-3.5 size-6 shrink-0 lg:size-10">
              <CommonIcon class="size-full text-p-900" name="globe-01" />
            </div>
            {{ feature01 }}
          </li>

          <li class="items-start gap-x-4 lg:flex">
            <div class="mb-3.5 size-6 shrink-0 lg:size-10">
              <CommonIcon class="size-full text-p-900" name="currency-dollar" />
            </div>
            {{ feature02 }}
          </li>

          <li class="items-start gap-x-4 lg:flex">
            <div class="mb-3.5 size-6 shrink-0 lg:size-10">
              <CommonIcon class="size-full text-p-900" name="layers-three-02" />
            </div>
            {{ feature03 }}
          </li>

          <li class="items-start gap-x-4 lg:flex">
            <div class="mb-3.5 size-6 shrink-0 lg:size-10">
              <CommonIcon class="size-full text-p-900" name="glasses-01" />
            </div>
            {{ feature04 }}
          </li>
        </ul>

        <ButtonContactUs
          class="mt-5 block w-full md:hidden"
          text="Contact Us"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CommonIcon from '~/components/common/Icon.vue'
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'

defineProps<{
  title: string
  feature01: string
  feature02: string
  feature03: string
  feature04: string
}>()
</script>
